<template>
<div>
  <b-table
      ref="feature-table"
      striped
      hover
      responsive
      v-bind:items="providers"
      v-bind:fields="fields"
      :busy="loading"
      @row-clicked="onRowClick"
  >
    <template #table-busy>
      <div class="text-center text-primary my-2">
        <b-spinner class="align-middle mx-1"></b-spinner>
        <strong>{{ msg('Loading') }}...</strong>
      </div>
    </template>
    <template #cell(clientId)="data">
      <div class="text-capitalize" style="white-space: nowrap">
        {{ data.item.clientName }}
      </div>
    </template>
    <template #cell(contractId)="data">
      <div class="text-capitalize" style="white-space: nowrap">
        <b-button variant="link" @click="openContract(data.item)" class="text-decoration-none text-capitalize m-0 px-0" :title="$t('View Contract')">
          {{ data.item.contractAddress }}
        </b-button>
      </div>
    </template>
    <template #cell(requestTime)="data">
      <div>
        {{ $moment(data.value).format('DD/MM/YY HH:mm') }}
      </div>
    </template>
    <template #cell(serviceTime)="data">
      <div>
        {{ $moment(data.value).format('DD/MM/YY HH:mm') }}
      </div>
    </template>
    <template #cell(status)="data">
      <span>{{$t(`providerServiceStatus.${data.value}`)}}</span>
    </template>
    <template #cell(paid)="data">
      <div>
        <b-badge v-if="data.value" variant="success">{{ msg('Paid') }}</b-badge>
      </div>
    </template>
  </b-table>
  <div class="text-center w-100">
    <div class="d-inline-block">
      <b-pagination
          v-model="page.currentPage"
          :total-rows="page.total"
          :per-page="page.amount"
          first-number
          last-number
          @input="refresh"
      />
    </div>
    <div class="d-inline-block px-2"><strong>{{ msg('Total') }}</strong> {{ page.total }}</div>
  </div>

  <provider-services-modal ref="providerServicesModal" @updated="refresh"/>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ProviderServicesModal from "@/components/modals/providers/ProviderServicesModal.vue";

export default {
  name: "ProviderServiceTable",
  components: {ProviderServicesModal},
  props:["filter"],
  watch: {
    filter: {
      deep: true,
      handler() {
        this.page.currentPage = 1; // Reset to first page on filter change
        this.refresh();
      },
      immediate: true
    },
  },
  data: () => ({
    loading: true,
    loadingStats: true,
    interval: null,
    providers: [],
    page: {amount: 10, currentPage: 1, total: 0},
    stats:{},
  }),
  computed: {
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    fields() {
      let $this = this
      return [
        {
          key: 'requestTime',
          label: $this.msg('requestTime'),
          sortable: false
        },
        {
          key: 'serviceTime',
          label: $this.msg('serviceTime'),
          sortable: false
        },
        {
          key: 'name',
          label: $this.msg('name'),
          sortable: true
        },
        {
          key: 'clientId',
          label: $this.msg('client'),
          sortable: true
        },
        {
          key: 'contractId',
          label: $this.msg('contract'),
          sortable: true
        },
        {
          key: 'amount',
          label: $this.msg('amount'),
          sortable: true
        }, {
          key: 'price',
          label: $this.msg('price'),
          sortable: true
        },
        {
          key: 'paid',
          label: $this.msg('paid'),
          sortable: true
        },
        {
          key: 'status',
          label: $this.msg('status'),
          sortable: true
        },
      ]
    },
  },
  created() {
    this.interval = setInterval(this.fetchData, 10_000); // Refresh every 10 seconds
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods:{
    ...mapActions('providersServices', ['fetchAllProvidersServices']),
    refresh() {
      let $this = this;
      this.loading = true;
      this.fetchData().finally(() => {
        $this.loading = false;
      });
    },
    fetchData(){
      let $this = this;
      return this.fetchAllProvidersServices({
        page: this.page.currentPage,
        amount: this.page.amount,
        filter: this.filter
      }).then(data => {
        $this.providers = data.ProviderServices;
        $this.page.amount = data['Amount']
        $this.page.total = data['Total']
        $this.page.currentPage = data['Page']
      })
    },
    openContract(feature) {
      window.open(`/real_estate/contracts/rent/${feature.contractId}#guest-feature`, '_blank');
    },
    onRowClick(provider) {
      this.$refs.providerServicesModal.show(provider.id, provider.contractId);
    }
  }
}
</script>



<style scoped>

</style>